/**
 * @ngdoc controller
 * @name CampaignsPlaceHolder
 * @description
 * This component renders a list of placeholders the campaign list.
 * The template was create based on this post:
 * https://cloudcannon.com/deconstructions/2014/11/15/facebook-content-placeholder-deconstruction.html
 *
 * @memberof home
 */
class CampaignsPlaceHolder {
  /**
   * Class constructor
   * @ignore
   */
  constructor() {
    /**
     * List of place holder; we need a list to iterate on the template.
     * @type {Array}
     */
    this.items = [];
  }

  /**
   * After the component initialization, generate the items list with the
   * value the implementation sent or a default one.
   */
  $onInit() {
    const defaultNumberOfItems = 5;
    this._generateItems(this.numberOfItems || defaultNumberOfItems);
  }

  /**
   * Check if the numberOfItems binding value changed in order to
   * re generate the list of placeholders.
   */
  $onChanges(changes) {
    if (changes.numberOfItems && angular.isDefined(changes.numberOfItems.currentValue)) {
      this._generateItems(changes.numberOfItems.currentValue);
    }
  }

  /**
   * Update the list of place holders.
   * @param  {Integer} numberOfItems the new number of items to show.
   */
  _generateItems(numberOfItems) {
    this.items = new Array(numberOfItems);
  }
}

export default CampaignsPlaceHolder;



// WEBPACK FOOTER //
// ./src/frontend/modules/home/components/campaignsPlaceHolder/campaignsPlaceHolder.controller.js